import React from 'react'

function TwitterDetails({ selectedSubCategory, twitter }) {
    return (
        <>
            {((selectedSubCategory === "Twitter") ?
             <div className='flex flex-col items-center bg-gray-50 rounded-xl '>
                <div className='flex flex-row justify-normal self-center  '>
                    <img className='rounded-md h-20 w-20' src={twitter?.profile_pic_url} alt="thumbnail"></img>
                    <div className='flex flex-col mx-5'>
                        <div className=' font-semibold my-3'>{twitter?.name}</div>
                        <div className='flex flex-row justify-normal gap-5 '>
                            <div>Tweets: <span className='font-semibold'>{twitter?.number_of_tweets}</span> </div>
                            <div>Following: <span className='font-semibold'>{twitter?.following_count}</span>  </div>
                            <div>Followers: <span className='font-semibold'>{twitter?.follower_count}</span> </div>
                            <div>Likes: <span className='font-semibold'>{twitter?.favourites_count}</span> </div>
                        </div>
                    </div>
                </div>

            </div> : null)}

        </>
    )
}

export default TwitterDetails